import type { FaireProductEntity } from "../../entity_types/product";

export const p_fs72p959vh: FaireProductEntity = {
  token: "p_fs72p959vh",
  type: "product",
  name: "Hyland's - Bioplasma 12 in 1 Cell Salt - 1 Each-100 Tablets",
  brandToken: "b_7xgwjjb7p6",
  brandName: "Unknown Brand",
  imageUrl:
    "https://cdn.faire.com/fastly/83bd9c6afea6671098cb0e7ce361328407d7e7945a2d8c0ca2284c59eab623cf.jpeg",
  galleryImageUrls: [],
  priceDollars: 17.54,
  description:
    "Discover the holistic benefits of balanced mineral nutrition with this comprehensive blend of cell salts. Each bottle contains 100 tablets, formulated to support overall health and wellness by combining 12 essential mineral cell salts. This versatile remedy is designed to aid in the body's natural healing processes.\n\n * Supports general vitality and well-being \n * Combines 12 mineral cell salts in one formula \n * Ideal for maintaining overall health balance \n * Easy-to-take, dissolvable tablets \n * Packaged for convenience and daily use \nIncorporate these tablets into your daily routine to promote a healthier lifestyle naturally.",
  tags: [],
  msrpDollars: 35.07,
  inStock: true,
  meta: {
    source: "api",
    importedAt: "2026-03-26T22:25:38.921Z",
    importedBy: "entity-db-cli",
  },
  categoryTokens: [],
};
